import styled from 'styled-components';

export const VoteActionsWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
`;

export const VoteButton = styled.button<{ $active?: boolean; $variant?: 'up' | 'down'; $buttonColor: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: transparent;
  background-color: ${({ $active, $variant, $buttonColor }) =>
    $active ? ($variant === 'down' ? '#d32f2f' : $buttonColor) : '#fff'};
  color: ${({ $active }) => ($active ? '#fff' : '#767676')};
  cursor: pointer;
  padding: 0;
  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${({ $variant, $buttonColor }) => ($variant === 'down' ? '#d32f2f' : $buttonColor)};
    color: ${({ $variant, $buttonColor }) => ($variant === 'down' ? '#d32f2f' : $buttonColor)};
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const VoteButtonDown = styled(VoteButton)`
  svg {
    transform: rotate(180deg);
  }
`;

export const StarVoteWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 8px;
`;

export const StarButton = styled.button<{ $active?: boolean; $buttonColor: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${({ $active, $buttonColor }) => ($active ? $buttonColor : '#ccc')};
  transition: color 0.15s ease;

  &:hover:not(:disabled) {
    color: ${({ $buttonColor }) => $buttonColor};
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const StarDisplayWrap = styled.div<{ $bgColor: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  background-color: ${({ $bgColor }) => $bgColor};
  border-radius: 8px;
  color: #fff;
  padding: 4px 8px 6px;
  min-width: 50px;
  text-align: center;
`;

export const StarDisplayRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1px;

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const StarDisplayActive = styled.span<{ $buttonColor: string }>`
  color: ${({ $buttonColor }) => $buttonColor};
  display: inline-flex;
`;

export const StarDisplayHalf = styled.span<{ $buttonColor: string }>`
  position: relative;
  display: inline-flex;
  color: #ccc;

  /* Half-filled overlay clipped to left 50% */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    overflow: hidden;
  }

  /* First SVG (background) stays gray; second (overlay) is colored via wrapper */
  svg:first-of-type {
    color: #ccc;
  }
  svg:last-of-type {
    position: absolute;
    left: 0;
    top: 0;
    color: ${({ $buttonColor }) => $buttonColor};
    clip-path: inset(0 50% 0 0);
  }
`;

export const StarDisplayInactive = styled.span`
  color: #ccc;
  display: inline-flex;
`;

export const StarRatingCount = styled.span`
  font-size: 10px;
  color: #fff;
`;

export const PointsAwardWrap = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;
  position: relative;
`;

export const PointsAwardTrigger = styled.button<{ $hasVote?: boolean; $buttonColor: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 8px;
  border: 0;
  background-color: #eaecff;
  color: ${({ $hasVote, $buttonColor }) => ($hasVote ? $buttonColor : '#767676')};
  cursor: pointer;
  font:
    600 11px 'Nunito',
    -apple-system,
    BlinkMacSystemFont,
    helvetica,
    arial,
    sans-serif;
  text-transform: uppercase;
  transition: all 0.15s ease;
  white-space: nowrap;

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

export const PointsPopup = styled.div`
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 8px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 200;
`;

export const PointOption = styled.button<{ $active?: boolean; $buttonColor: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: 1px solid ${({ $active, $buttonColor }) => ($active ? $buttonColor : '#ddd')};
  background-color: ${({ $active, $buttonColor }) => ($active ? $buttonColor : '#fff')};
  color: ${({ $active }) => ($active ? '#fff' : '#2c3548')};
  cursor: pointer;
  font:
    600 12px 'Nunito',
    -apple-system,
    BlinkMacSystemFont,
    helvetica,
    arial,
    sans-serif;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${({ $buttonColor }) => $buttonColor};
    background-color: ${({ $buttonColor }) => `${$buttonColor}1a`};
  }
`;

export const PointsPopupClose = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  color: #767676;
  cursor: pointer;
  padding: 0;
  margin-left: 4px;

  &:hover {
    color: #333;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;
